import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from "react-router-dom"; // Added Navigate
import { useState, useEffect } from "react";
import "./App.css";
import Dashboard from "./pages/Admin/Dashboard";
import Login from "./pages/Login";
import Header from "./components/Header";
import Sidebar from "./components/Sidebar";
import Forgot from "./pages/Forgot";
import AddStudents from "./pages/Admin/AddStudents";
import ProtectedRoute from "./components/ProtectedRoute";
import Students from "./pages/Admin/Students";
import AddTeachers from "./pages/Admin/AddTeachers";
import Teachers from "./pages/Admin/Teachers";
import AddParents from "./pages/Admin/AddParents";
import Parents from "./pages/Admin/Parents";
import Profile from "./pages/Admin/Profile";
import AdminSettings from "./pages/Admin/AdminSettings";
import Books from "./pages/Admin/Books";
import Classes from "./pages/Admin/Classes";
import AllClasses from "./pages/Admin/AllClasses";
import Subjects from "./pages/Admin/Subjects";
import AllSubjects from "./pages/Admin/AllSubjects";
import GenerateIdCards from "./pages/Admin/GenerateIdCards";
import IdCards from "./pages/Admin/IdCards";
import AttendanceTake from "./pages/Admin/AttendanceTake";
import AttendanceView from "./pages/Admin/AttendanceView";
import CreateRoutine from "./pages/Admin/CreateRoutine";
import Routine from "./pages/Admin/Routine";
import IssueReturn from "./pages/Admin/IssueReturn";
import ExamSchedule from "./pages/Admin/ExamSchedule";
import Grades from "./pages/Admin/Grades";
import NoticesAdd from "./pages/Admin/NoticesAdd";
import Notices from "./pages/Admin/Notices";
import HostelStudent from "./pages/Admin/HostelStudent";
import HostelRooms from "./pages/Admin/HostelRooms";
import TransportRoutes from "./pages/Admin/TransportRoutes";
import Vehicles from "./pages/Admin/Vehicles";
import TransportVehicles from "./pages/Admin/TransportVehicles";
import Payment from "./pages/Admin/Payment";
import Records from "./pages/Admin/Records";
import Reports from "./pages/Admin/Reports";

// Teachers
import TeacherDashboard from "./pages/Teacher/Dashboard";
import TeacherProfile from "./pages/Teacher/Profile";
// import YourStudents from "./pages/Teacher/YourStudents";
import TeacherAllStudnets from "./pages/Teacher/TeacherAllStudnets";
import StudentsParents from "./pages/Teacher/StudentsParents";
import TeacherClasses from "./pages/Teacher/TeacherClasses";
import TeacherRoutine from "./pages/Teacher/TeacherRoutine";
import TeacherAttendance from "./pages/Teacher/Attendance";
import TeacherExamSchedule from "./pages/Teacher/ExamSchedule";
import TeacherAllNotices from "./pages/Teacher/AllNotices";
import TeacherReports from "./pages/Teacher/Reports";
import ViewReports from "./pages/Teacher/ViewReports";
import ChangePassword from "./pages/Teacher/ChangePassword";

//  students and Guardian 
import StudentDashboard from "./pages/Student/Dashboard";
import StudentProfile from "./pages/Student/Profile";
import StudentChangePassword from "./pages/Student/ChangePassword";
import StudentClasses from "./pages/Student/StudentClasses";
import StudentRoutine from "./pages/Student/StudentRoutine";
import StudentAttendance from "./pages/Student/Attendance";
import StudentExamSchedule from "./pages/Student/StudentExamSchedule";




function Layout({ children }) {
  const location = useLocation();
  const noHeaderSidebarRoutes = ["/", "/forgot-password"];
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const hideHeaderSidebar = noHeaderSidebarRoutes.includes(location.pathname);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Toggle sidebar
  const toggleSidebar = () => {
    if (isMobile) {
      setMobileSidebarOpen(!mobileSidebarOpen);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  return (
    <div className="App">
      {!hideHeaderSidebar && (
        <Header toggleSidebar={toggleSidebar} />
      )}
      {!hideHeaderSidebar && (
        <Sidebar
          collapsed={sidebarCollapsed}
          isMobile={isMobile}
          mobileOpen={mobileSidebarOpen}
        />
      )}
      <main className={`main-content ${!hideHeaderSidebar ?
        (sidebarCollapsed ? 'sidebar-collapsed' : '') : 'no-sidebar'}`}>
        {children}
      </main>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/forgot-password" element={<Forgot />} />

          {/* Protected Admin Pages */}
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/students/add" element={<ProtectedRoute><AddStudents /></ProtectedRoute>} />
          <Route path="/students" element={<ProtectedRoute><Students /></ProtectedRoute>} />
          <Route path="/teachers/add" element={<ProtectedRoute><AddTeachers /></ProtectedRoute>} />
          <Route path="/teachers" element={<ProtectedRoute><Teachers /></ProtectedRoute>} />
          <Route path="/parents/add" element={<ProtectedRoute><AddParents /></ProtectedRoute>} />
          <Route path="/parents" element={<ProtectedRoute><Parents /></ProtectedRoute>} />
          <Route path="/admin/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
          <Route path="/library/books" element={<ProtectedRoute><Books /></ProtectedRoute>} />
          <Route path="/library/issue-return" element={<ProtectedRoute><IssueReturn /></ProtectedRoute>} />
          <Route path="/classes/add" element={<ProtectedRoute><Classes /></ProtectedRoute>} />
          <Route path="/classes" element={<ProtectedRoute><AllClasses /></ProtectedRoute>} />
          <Route path="/subjects/add" element={<ProtectedRoute><Subjects /></ProtectedRoute>} />
          <Route path="/subjects" element={<ProtectedRoute><AllSubjects /></ProtectedRoute>} />
          <Route path="/generate-idCards" element={<ProtectedRoute><GenerateIdCards /></ProtectedRoute>} />
          <Route path="/id-cards" element={<ProtectedRoute><IdCards /></ProtectedRoute>} />
          <Route path="/attendance/take" element={<ProtectedRoute><AttendanceTake /></ProtectedRoute>} />
          <Route path="/attendance/view" element={<ProtectedRoute><AttendanceView /></ProtectedRoute>} />
          <Route path="/routine/create" element={<ProtectedRoute><CreateRoutine /></ProtectedRoute>} />
          <Route path="/routine" element={<ProtectedRoute><Routine /></ProtectedRoute>} />
          <Route path="/exam/schedule" element={<ProtectedRoute><ExamSchedule /></ProtectedRoute>} />
          <Route path="/exam/grades" element={<ProtectedRoute><Grades /></ProtectedRoute>} />
          <Route path="/notices/add" element={<ProtectedRoute><NoticesAdd /></ProtectedRoute>} />
          <Route path="/notices" element={<ProtectedRoute><Notices /></ProtectedRoute>} />
          <Route path="/hostel/rooms" element={<ProtectedRoute><HostelRooms /></ProtectedRoute>} />
          <Route path="/hostel/students" element={<ProtectedRoute><HostelStudent /></ProtectedRoute>} />
          <Route path="/transport/routes" element={<ProtectedRoute><TransportRoutes /></ProtectedRoute>} />
          <Route path="/transport/vehicles" element={<ProtectedRoute><Vehicles /></ProtectedRoute>} />
          <Route path="/transport/vehicles" element={<ProtectedRoute><TransportVehicles /></ProtectedRoute>} />
          <Route path="/payroll/payment" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
          <Route path="/payroll/records" element={<ProtectedRoute><Records /></ProtectedRoute>} />
          <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />

          {/* Teacher pages */}
          <Route path="/dashboard/teacher" element={<ProtectedRoute><TeacherDashboard /></ProtectedRoute>} />
          <Route path="/teacher/profile" element={<ProtectedRoute><TeacherProfile /></ProtectedRoute>} />
          {/* <Route path="/teacher/students" element={<ProtectedRoute><YourStudents /></ProtectedRoute>} /> */}
          <Route path="/teacher/allStudents" element={<ProtectedRoute><TeacherAllStudnets /></ProtectedRoute>} />
          <Route path="/teacher/allParents" element={<ProtectedRoute><StudentsParents /></ProtectedRoute>} />
          <Route path="/teacher/classes" element={<ProtectedRoute><TeacherClasses /></ProtectedRoute>} />
          <Route path="/teacher/routine" element={<ProtectedRoute><TeacherRoutine /></ProtectedRoute>} />
          <Route path="/teacher/attendance" element={<ProtectedRoute><TeacherAttendance /></ProtectedRoute>} />
          <Route path="/teacher/exam/schedule" element={<ProtectedRoute><TeacherExamSchedule /></ProtectedRoute>} />
          <Route path="/teacher/notices" element={<ProtectedRoute><TeacherAllNotices /></ProtectedRoute>} />
          <Route path="/teacher/report" element={<ProtectedRoute><TeacherReports /></ProtectedRoute>} />
          <Route path="/teacher/reports" element={<ProtectedRoute><ViewReports /></ProtectedRoute>} />
          <Route path="/teacher/changePassword" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />

          {/* students and Guardian */}
          <Route path="/student/dashboard" element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>} />
          <Route path="/student/profile" element={<ProtectedRoute><StudentProfile /></ProtectedRoute>} />
          <Route path="/student/changePassword" element={<ProtectedRoute><StudentChangePassword /></ProtectedRoute>} />
          <Route path="/student/classes" element={<ProtectedRoute><StudentClasses /></ProtectedRoute>} />
          <Route path="/student/routine" element={<ProtectedRoute><StudentRoutine /></ProtectedRoute>} />
          <Route path="/student/attendance" element={<ProtectedRoute><StudentAttendance /></ProtectedRoute>} />
          <Route path="/student/exam/schedule" element={<ProtectedRoute><StudentExamSchedule /></ProtectedRoute>} />
          

          {/* 404 route */}
          {/* npm install jsbarcode html2canvas */}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;